import { Input, makeStyles } from '@rneui/themed'
import React from 'react'
import { View } from 'react-native'
import { EditViewProps } from '../screen'

export function EditConversationDescriptionView({
  value,
  onChangeValue,
}: EditViewProps) {
  const styles = useStyles()

  return (
    <View style={styles.container}>
      <Input
        style={styles.input}
        placeholder={'Enter description'}
        value={value}
        multiline
        autoFocus
        onChangeText={onChangeValue}
      />
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.colors?.white,
    margin: 10,
    padding: 10,
  },
  input: {
    height: 200,
    textAlignVertical: 'top',
    color: theme.colors?.grey2,
  },
}))
